// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RelationIn = zod.object({
  "to_asset_id": zod.uuid(),
  "type": zod.enum(['built_from', 'part_of'])
});

export type RelationIn = zod.input<typeof RelationIn>;
export type RelationInOutput = zod.output<typeof RelationIn>;
